import querystring from 'query-string'

export const parseListParams = (locationSearch) => {
    let parsed = querystring.parse(locationSearch)
    let page = parsed.page? parseInt(parsed.page) : 1
    let searchKeyword = parsed.searchKeyword? parsed.searchKeyword : ''
    let searchType = parsed.searchType? parsed.searchType: 'writer'

    return {
        page: page,
        searchKeyword: searchKeyword,
        searchType : searchType,
    }
}
